import React, { useEffect } from 'react'
import { webview } from '../../../app/api/webview'
import MobileView from './MobileView'
import { useNavigate } from 'react-router-dom'

const MeetingPlatform = () => {
    const navigate = useNavigate()
        useEffect(() => {
            const handlePopState = () => {
              navigate('/home/announcement/gatewaybox');
            };
        
            window.addEventListener('popstate', handlePopState);
            return () => window.removeEventListener('popstate', handlePopState);
          }, []);
    
            useEffect(() => {
              const handleMessage = (event) => {
                try {
                  console.log('message', event.data);
                  const message = event.data;
                  if (message.type == 'GBOXClose') {
                    // dispatch(toggleOutlet(false));
                    navigate('/home/announcement/gatewaybox');
                    console.log('GBOXClose');
                  }
                } catch (error) {}
              };
              window.addEventListener('message', handleMessage);
              return () => {
                window.removeEventListener('message', handleMessage);
              };
            }, []);
  return (
    <MobileView URL={webview.Meetingplatform} comingSoon={true} />
  )
}

export default MeetingPlatform